export const SESSION_SUPERSEDED_DETAIL = "SESSION_SUPERSEDED";

export function isSessionSupersededDetail(detail: unknown): boolean {
  return detail === SESSION_SUPERSEDED_DETAIL;
}
